export const GRID = 32;

// De gereedschapsknoppen in het tekenscherm worden nooit groter dan dit, en ze
// zijn vierkant.
//
// De maat komt van de kleurvakjes aan de andere kant van het doek, zodat links en
// rechts even grote knoppen staan. Die kolom is 152 breed met een rand van 4 en
// 12 padding, dus 152-4-24 = 124 binnenruimte; twee vakjes met 8 ertussen maakt
// (124-8)/2 = 58.
//
// De kolom links is daarop gemaakt: 58 knop + 2x10 padding + 4 rand = 82. Precies
// dat maakt de knoppen vierkant. Verander je een van deze getallen, dan moeten de
// andere mee, en ook sideW in computeCanvasSize.
export const TOOL_MAX = 58;
export const TOOL_COL_W = 82;

// Breedte/hoogte van het canvas: 32×32 solo, 64×32 als je samen krabbelt.
export let GW = GRID, GH = GRID;

export const PB_URL = 'https://server.gertbuist.nl';

// Ideeën van vóór het authorId-veld: oude schrijversnaam -> huidig accountId.
export const LEGACY_AUTHOR_IDS = { 'Coen': 'wx22i40o4hhik30' };

// g3rt: mag ideeën als opgelost markeren.
export const MAINTAINER_ID = 'gsaeu7g4wn07v5v';

/**
 * Wat er misgaat als het veld `beta` nog niet op de server staat.
 *
 * Dezelfde truc als PIN_FAIL_MSG hierboven: de app blijft werken, en de melding
 * zegt precies wat er moet gebeuren. PocketBase negeert een veld dat het niet kent
 * zonder te klagen, dus je merkt het alleen doordat het vinkje niet blijft staan.
 * Daarom leest de app na het opslaan terug wat er echt in de regel staat.
 */
export const BETA_FAIL_MSG = 'Niet opgeslagen. De collectie paal_accounts heeft nog geen ja/nee-veld beta op de server.';

export const BROADCAST_AV = 'data:image/svg+xml,' + encodeURIComponent('<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32"><rect width="32" height="32" rx="7" fill="#ff5c8a"/><text x="16" y="23" font-size="19" text-anchor="middle">📣</text></svg>');

export const COMMENT_MAX_CHARS = 30;

export const BIO_MAX = 30;

export const AV = 8;

export const AV_EMPTY = '.'.repeat(AV * AV);

export const PIN_FAIL_MSG = 'Pincode niet opgeslagen. De collectie paal_accounts heeft nog geen tekstveld pinHash op de server.';

/**
 * Het nummer naast het logo, en tegelijk de sleutel waarop de bel bijhoudt of je
 * het nieuws van deze versie al gezien hebt (`gp_notif_seen_` plus dit nummer, zie
 * logic/lifecycle.js). Draai je hieraan, dan springt bij iedereen het bolletje op
 * de bel één keer aan. Dat is de bedoeling: een nieuwe versie is nieuws.
 */
export const APP_VERSION = 'v3.0';

// Tot zoveel beelden mag één krabbel bewegen.
export const MAX_FRAMES = 6;

// Doorzichtig plaatje van 1×1 voor een beeld dat nog leeg is.
export const BLANK_PNG = 'data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7';

// Naar beneden trekken op de telefoon ververst de paal: hoever hij meegeeft,
// en vanaf waar loslaten echt ververst.
export const PULL_MAX = 78;

export const PULL_TRIGGER = 52;

// Het gastenboek: één gedeeld vel van 32×32 waar iedereen elke dag 20 pixels op mag zetten.
export const GB = 32;

export const GB_EMPTY = '.'.repeat(GB * GB);

export const GB_PER_DAY = 20;

// Rasterlijnen als vector, zodat ze exact met de pixels meeschalen.
export const GB_GRID_URL = 'url("data:image/svg+xml;utf8,' + encodeURIComponent(
  '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" preserveAspectRatio="none">' +
  '<g stroke="rgba(36,27,58,0.13)" stroke-width="0.06">' +
  Array.from({ length: 31 }, (_, i) => '<path d="M' + (i + 1) + ' 0V32M0 ' + (i + 1) + 'H32"/>').join('') +
  '</g></svg>') + '")';

export const BUZZ_PREFIX = 'BUZZ!';

export const BUZZ_COOLDOWN = 600000;

// Plat ovaaltje (stadion-vorm) met een gelijkmatig verdeelde kartelrand: rechte
// stukken en de twee ronde uiteinden krijgen allebei tanden van gelijke grootte.
export const BUZZ_W = 340, BUZZ_H = 58;

// Je bent online tot 60 seconden na je laatste hartslag.
export const ONLINE_MS = 60000;

export const EMOJIS = ['😀','😂','🥰','😎','😭','😡','👍','👎','🙌','👀','🎨','🖌️','✨','🔥','🌈','⭐','❤️','💜','🍕','🍰','🐱','🐶','🚀','🎉'];

// Hier stond EMOJIS_BAR: een greeplade van twaalf tekentjes voor de chatbalk in de
// taakbalk. Die balk is er niet meer (zie logic/desktop.js), en het chatvenster
// gebruikt de volle set hierboven.

/** Samen krabbelen verdubbelt het doek naar 64x32. Zie logic/duo.js. */
export function setGridSize(w, h) {
  GW = w;
  GH = h;
}

// Ideeën, de krabbel van de dag en het thema van vandaag liggen per dag vast of
// veranderen hooguit een paar keer per week. Zie fetchDayData in logic/lifecycle.js.
export const DAY_POLL_MS = 300000;

// De taakbalk onderin. Alles wat in beeld staat schuift er precies bovenuit, dus
// deze hoogte staat als onderrand op het hele scherm.
//
// Even hoog als de kop erboven, die dezelfde maat vast krijgt in headerStyle. De
// twee balken staan recht tegenover elkaar; een paar pixels verschil zie je.
export const TASKBAR_H = 64;

/**
 * Op welke hoogtes het bureaublad gestapeld staat.
 *
 * De programmaatjes liggen tussen Z_VENSTER en Z_VENSTER_MAX; welk venster precies
 * waar ligt hangt af van wat je het laatst aanraakte (zie vensterZ in
 * logic/venster.js). De taakbalk ligt daarboven, en dat is het punt: hij is het
 * scherm zelf en niet een van de programma's. Hij stond op 70 en lag daarmee onder
 * elk venster, dus zodra er een venster over de balk heen hing was de startknop
 * eronder half weg. Het uitklapmenu van de bel hangt in de balk en gaat dus mee.
 *
 * Boven de balk zit alleen nog de laag van de schermvullende vensters, op 97.
 */
export const Z_VENSTER = 90;
export const Z_VENSTER_MAX = 95;
export const Z_BALK = 96;

/**
 * En daarboven de schermvullende vensters: alles met een donkere laag eronder.
 *
 * Die stonden verspreid over 80, 82, 86, 88, 90, 92, 93, 94, 95, 96, 97, 98 en 99,
 * en dat werkte zolang er nooit twee dingen tegelijk open stonden. Zodra er een
 * venster open staat (het tekenvenster stond een tijd open bij binnenkomst, en
 * daardoor viel het op), bleek de helft van de app erachter te vallen: de krabbel die je
 * aanklikte, het postvakje, de ideeënbus, het leaderbord, de arcadehal, en het
 * plakvenster waarmee je je werk op de paal zet.
 *
 * Drie hoogtes zijn genoeg:
 *
 * - `Z_LAAG` voor elk schermvullend venster. Bijna alles hangt aan `state.dialog`
 *   en er kan er dus maar één van open zijn; die hoeven onderling niets te weten.
 * - `Z_LAAG_BOVEN` voor een venster dat over zo'n venster heen komt: de lijst met
 *   thema's boven het themablokje, het feestje boven het plakvenster, een
 *   uitnodiging die binnenvalt terwijl je iets anders doet.
 * - `Z_LAAG_TOP` voor de drie die over de accountlade heen moeten: de pincode, de
 *   avatar-tekenaar en de vraag of je echt wil uitloggen.
 *
 * Daarboven zit alleen de melding op 100, en die hoort altijd bovenaan.
 */
export const Z_LAAG = 97;
export const Z_LAAG_BOVEN = 98;
export const Z_LAAG_TOP = 99;

/** De titelbalk van het tekenvenster, die van de doekhoogte af gaat. */
export const STUDIO_BALK = 46;

// De chatkolom naast de paal.
//
// De som die hier stond klopte niet meer: hij rekende met 12 padding, een avatar van
// 26 en een gat van 9, terwijl het venster 20 en 6 doet. Dat is precies waarom een
// som in een comment een slecht idee is; hij verandert niet mee.
//
// Reken hem daarom niet na maar meet hem: 360 is wat een bericht van veertig tekens
// nodig heeft om op één regel te passen. Wil je eraan draaien, zet dan het
// chatvenster open, typ zo'n bericht, en kijk waar het afbreekt.
export const CHAT_W = 360;
// Vanaf deze breedte past de chat ernaast. Krap gerekend: de zijbalk loopt tot 292
// (ZIJBALK_TOT in logic/board.js), de chat pakt 360, en daartussen moet de paal van
// 280 met zijn overhangende krabbels passen. Onder deze breedte valt de chat terug op
// de knop in de taakbalk.
export const CHAT_DOCK_MIN = 960;


// Het geborstelde metaal van de paal zelf.
export const POLE_BG =
  'linear-gradient(90deg,#4a494f 0.0% 2.4%,#626169 2.4% 4.8%,#74737c 4.8% 7.1%,#84838b 7.1% 9.5%,#929198 9.5% 11.9%,#9f9ea4 11.9% 14.3%,#aaa9ae 14.3% 16.7%,#b5b4b8 16.7% 19.0%,#bebdc1 19.0% 21.4%,#c7c6c9 21.4% 23.8%,#cfced1 23.8% 26.2%,#d6d5d7 26.2% 28.6%,#dcdcdd 28.6% 31.0%,#e1e1e2 31.0% 33.3%,#e6e6e7 33.3% 35.7%,#eaeaeb 35.7% 38.1%,#eeeeee 38.1% 40.5%,#f0f0f1 40.5% 42.9%,#f3f2f3 42.9% 45.2%,#f4f4f4 45.2% 47.6%,#f5f5f5 47.6% 50.0%,#f5f5f5 50.0% 52.4%,#f4f4f4 52.4% 54.8%,#f3f2f3 54.8% 57.1%,#f0f0f1 57.1% 59.5%,#eeeeee 59.5% 61.9%,#eaeaeb 61.9% 64.3%,#e6e6e7 64.3% 66.7%,#e1e1e2 66.7% 69.0%,#dcdcdd 69.0% 71.4%,#d6d5d7 71.4% 73.8%,#cfced1 73.8% 76.2%,#c7c6c9 76.2% 78.6%,#bebdc1 78.6% 81.0%,#b5b4b8 81.0% 83.3%,#aaa9ae 83.3% 85.7%,#9f9ea4 85.7% 88.1%,#929198 88.1% 90.5%,#84838b 90.5% 92.9%,#74737c 92.9% 95.2%,#626169 95.2% 97.6%,#4a494f 97.6% 100.0%)';
